import requests from "./httpService";

const AdminServices = {

  addPermission: async (body) => {
    return requests.post("/permission/add", body);
  },
  getAllPermission: async () => {
    return requests.get("/permission/");
  },
  getPermissionById: async (id) => {
    return requests.get(`/permission/${id}`);
  },

  // updatePermission: async (id, body) => {
  //   return requests.put(`/permission/update/${id}`, body);
  // },

  // deletePermission: async (id) => {
  //   return requests.put(`/permission/delete/${id}`);
  // },
 
};

export default AdminServices;
